import {
	AzureTicketCreatorConfig,
	ResolvedAzureTicketCreatorConfig
} from '../types/AzureTicketCreatorConfig';

/** Azure DevOps REST base used when the host does not override `apiBaseUrl`. */
const DEFAULT_AZURE_API_BASE_URL = 'https://dev.azure.com';
/** vssps (users/graph) base used when the host does not override `usersBaseUrl`. */
const DEFAULT_AZURE_USERS_BASE_URL = 'https://vssps.dev.azure.com/';

/** Apply defaults so optional config fields become concrete values. */
export const resolveAzureConfig = (
	config: AzureTicketCreatorConfig
): ResolvedAzureTicketCreatorConfig => ({
	clientId: config.clientId,
	redirectUri: config.redirectUri,
	apiBaseUrl: config.apiBaseUrl || DEFAULT_AZURE_API_BASE_URL,
	usersBaseUrl: config.usersBaseUrl || DEFAULT_AZURE_USERS_BASE_URL,
	logger: config.logger ?? console,
	appElement: config.appElement
});
